import { render, staticRenderFns } from "./SimpleRouterView.vue?vue&type=template&id=2cf52bac&"
import script from "./SimpleRouterView.vue?vue&type=script&lang=ts&"
export * from "./SimpleRouterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports